import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import theme from './assets/theme';
import './App.css';
import MainPage from './pages/Main/index';
import { store as ReduxStore } from './redux';

/**
 * @returns {React.ReactElement} return the Main routing page
 */
const App = () => {
  return (
    <Provider store={ReduxStore}>
      <ThemeProvider theme={theme}>
        <Router>
          <MainPage />
        </Router>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
